import React from 'react'
import styled from 'styled-components'
import { deviceLessThan, deviceGreaterThan } from '../../styles/breakpoints';

/**
* BannerContainer
*
*/

export const BenefitCard = styled.div`
    width: ${props => props.width && props.width};
    max-width:${props => props.maxWidth && props.maxWidth};
    height:${props => props.height && props.height};
    border-radius: 6px;
    box-shadow: 0 0 13px 1px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    padding: ${props => props.padding ? props.padding : '22px'};
    display: flex;
    flex-direction: column;
    height:100%;
    @media ${deviceLessThan.tablet} {
        padding: ${props => props.sPadding ? props.sPadding : '12px'};
        margin:${props => props.sMargin && props.sMargin};
        width:${props => props.sWidth ? props.sWidth : "450px"};
    }
`;

export const OvalBackground = styled.div`
  position: ${props => props.position ? props.position: 'absolute'};
  width: ${props => props.diameter ? props.diameter: '658px'};
  height: ${props => props.diameter ? props.diameter: '658px'};
  opacity: ${props => props.opacity ? props.opacity: 0.05};
  background-image: linear-gradient(to bottom, #0285d3, #02aae9);
  border-radius: 50%;
  top: ${props => props.top && props.top};
  left: ${props => props.left && props.left};
`;

export const BannerImageWrapper = styled.div`
    position: relative;
    width: 30%;
`;

export const ProductCardContainer = styled.div`
    background:${props => props.background && props.background};
    background-size:${props => props.backgroundSize && props.backgroundSize};
    padding:5px 0px 0px;
    position:relative;
    @media ${deviceLessThan.tablet} {
    background-size:${props => props.sBackgroundSize && props.sBackgroundSize};
    background:${props => props.sBackground && props.sBackground};
       
    }
`;